// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const DeliveryOrderService = {};

function buildQuery(params) {
  return Object.entries(params)
    .filter(([_, v]) => v !== null && v !== undefined && v !== "")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");
}

DeliveryOrderService.getSearchListDOBAstService = function (data) {
  const dataIndex = data.pageIndex || 0;
  const decrementIndex = dataIndex === 0 ? 0 : dataIndex - 1;

  const params = {
    pageSize: data.pageSize,
    pageIndex: decrementIndex,
    poNo: data?.poNo,
    branchId: data?.branchId,
    startPurchaseOrderDate: data?.startPurchaseOrderDate,
    endPurchaseOrderDate: data?.endPurchaseOrderDate,
    name: data?.name,
    noLoan: data?.noLoan,
    nameCustomer: data?.nameCustomer,
  };

  return lossClient({
    url: `/PurchaseOrder/SearchListDOBAst?${buildQuery(params)}`,
    method: "get",
  });
};

DeliveryOrderService.getSearchListDoApprovalService = function (data) {
  const dataIndex = data.pageIndex || 0;
  const decrementIndex = dataIndex === 0 ? 0 : dataIndex - 1;

  const params = {
    pageSize: data.pageSize,
    pageIndex: decrementIndex,
    poNo: data?.poNo,
    branchId: data?.branchId,
    startPurchaseOrderDate: data?.startPurchaseOrderDate,
    endPurchaseOrderDate: data?.endPurchaseOrderDate,
    name: data?.name,
    noLoan: data?.noLoan,
    nameCustomer: data?.nameCustomer,
  };

  return lossClient({
    url: `/DeliveryOrder/SearchListDoApproval?${buildQuery(params)}`,
    method: "get",
  });
};

DeliveryOrderService.addDeliveryOrderService = function (data) {
  return lossClient({
    url: `/DeliveryOrder/add`,
    method: "post",
    headers: {},
    data: data,
  });
};

DeliveryOrderService.putApproveDeliveryOrderService = function (payload) {
  return lossClient({
    url: "/DeliveryOrder/ApproveDeliveryOrder",
    method: "put",
    headers: {
      "x-requestId": payload?.id ?? "",
    },
    data: payload?.data ?? {},
  });
};

DeliveryOrderService.putRejectedDeliveryOrderService = function (payload) {
  return lossClient({
    url: "/DeliveryOrder/RejectedDeliveryOrder",
    method: "put",
    headers: {
      "x-requestId": payload?.id ?? "",
    },
    data: payload?.data ?? {},
  });
};

DeliveryOrderService.getDeliveryOrderSoftCopyService = function (data) {
  const params = {
    poNo: data.poNo,
  };

  return lossClient({
    url: `/DeliveryOrder/DeliveryOrderSoftCopy?${buildQuery(params)}`,
    method: "get",
  });
};
export default DeliveryOrderService;
